var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    id: "dollar-tag_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dollar-tag_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dollar-tag_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.89 12.11l.55-.55M8.57 15.43l-.55.55M8.013 14.071c-.091.377-.009.783.286 1.078l.276.276.329.329a1.096 1.096 0 001.715-1.338l-.775-1.294a1.097 1.097 0 011.715-1.338l.329.329.276.276c.294.294.376.699.287 1.075M15.807 8.193a.371.371 0 11-.524.524.371.371 0 01.524-.524"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.512 4h4.385C19.059 4 20 4.941 20 6.102v4.385c0 .558-.222 1.092-.616 1.487l-8.41 8.41a2.102 2.102 0 01-2.973 0l-4.385-4.385a2.102 2.102 0 010-2.973l8.41-8.41A2.103 2.103 0 0113.512 4z"
  }))));
}
export default SvgDollarTag;


//////////////////
// WEBPACK FOOTER
// ./src/icons/dollar-tag.svg
// module id = 81
// module chunks = 13